import React from "react";

const DH = ({ width = 32, height = 32, className }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="32" height="32" rx="16" fill="white" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.893 12.8361C13.502 8.58228 9.83505 8.71986 9.83505 8.71986H3.25275V9.26465C3.25275 9.26465 4.56921 9.3472 4.77174 10.2112V21.7894C4.56921 22.6588 3.25275 22.7359 3.25275 22.7359V23.2807H9.1635C11.8284 23.2091 14.0403 21.5472 14.957 18.9113C15.9057 15.8407 14.893 12.8361 14.893 12.8361M12.7129 13.249C12.2759 10.5746 11.1513 9.94723 11.1513 9.94723C12.5317 10.3985 13.2512 12.7868 13.3312 15.3016C13.4164 18.0971 12.7023 21.0522 11.2099 21.674C11.2099 21.674 12.8515 20.4799 12.9048 15.9399C12.9154 15.8959 12.9314 15.2191 12.8888 14.6633C12.8355 13.9204 12.7129 13.249 12.7129 13.249M12.3721 15.8463C12.3721 15.8463 12.4254 18.4822 11.8018 19.9239C10.8691 22.6094 8.47066 22.3397 8.47066 22.3397C7.36739 22.2242 7.3514 21.2832 7.3514 21.2832L7.34607 9.83703C7.34607 9.83703 8.01229 9.5894 9.41403 9.63893C9.41403 9.63893 10.6719 9.57839 11.4927 10.9651C11.4927 10.9651 12.2868 12.3079 12.3401 14.4925L12.3721 15.8463ZM5.18763 10.1563H5.59803V21.8446H5.18763V10.1563Z"
      fill="#0091AC"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.0395 10.0915V21.903C27.0395 21.903 27.2728 22.6605 28.7472 22.7538V23.2752H22.4786V22.7538C22.4786 22.7538 23.7408 22.7428 24.1757 21.8975V16.1125H19.286V21.9085C19.286 21.9085 19.5194 22.6659 20.9937 22.7593V23.2807H14.7252V22.7593C14.7252 22.7593 15.9874 22.7483 16.4222 21.903V10.1025C15.9874 9.25724 14.7252 9.24626 14.7252 9.24626V8.72484H20.9937V9.24626C19.5194 9.33957 19.286 10.097 19.286 10.097V15.1685H24.1757V10.097C23.7408 9.25175 22.4786 9.24077 22.4786 9.24077V8.71935H28.7472V9.23528C27.2728 9.33408 27.0395 10.0915 27.0395 10.0915M16.8729 10.1683H17.3236V21.892H16.8729V10.1683ZM24.6426 10.163H25.0934V21.8867H24.6426V10.163Z"
      fill="#0091AC"
    />
  </svg>
);

export default DH;
